import { render } from "./ChallengeStatement.vue?vue&type=template&id=08d38e39&scoped=true"
import script from "./_ChallengeStatement.js?vue&type=script&lang=js&external"
export * from "./_ChallengeStatement.js?vue&type=script&lang=js&external"

import "./_ChallengeStatement.less?vue&type=style&index=0&id=08d38e39&lang=less&scoped=true&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08d38e39"]])

export default __exports__